import { Box, Theme } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@/components';
import { AppFooter, EpisodeDetails } from '@/containers';
import { PlayArrowFilledIcon, ShareIcon } from '@/icons';
import { AnalyticsService } from '@/services';
import {
  playerThunks,
  selectIsPlayerPlaying,
  useAppDispatch,
  useFetchCPACanadaEpisodeQuery,
} from '@/store';
import { SnackbarUtils } from '@/utils';

import {
  CPAContentEndModal,
  CPAHeader,
  CPAPlayer,
  CPASignUpModal,
} from './containers';

export const CPACanada = () => {
  const [episodeStarted, setStarted] = useState(false);
  const { data: cpaCanadaContent } = useFetchCPACanadaEpisodeQuery();
  const dispatch = useAppDispatch();
  const isPlaying = useSelector(selectIsPlayerPlaying);

  const playEpisode = () => {
    dispatch(
      isPlaying ? playerThunks.pausePlayer() : playerThunks.playPlayer(),
    );

    if (!episodeStarted) {
      const identifier = cpaCanadaContent!.episode.contentId;
      AnalyticsService.episodeStart({
        chapterId: identifier,
        episodeId: identifier,
        location: { page: 'Cpa Canada', button: 'banner play' },
        referrer: { page: 'Cpa Canada', button: 'banner play' },
        hasTranscript: false,
        hasVisualAid: false,
      });
    }

    setStarted(true);
  };

  return (
    <Box sx={styles.pageContainer}>
      <CPASignUpModal cpaCanadaContent={cpaCanadaContent} />
      <CPAContentEndModal cpaCanadaContent={cpaCanadaContent} />
      <Box sx={styles.fullWidthBox}>
        <CPAHeader cpaCanadaContent={cpaCanadaContent} />
        <CPAPlayer cpaCanadaContent={cpaCanadaContent} />
        {!!cpaCanadaContent?.episode && (
          <EpisodeDetails
            episode={cpaCanadaContent.episode}
            customControls={
              <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                <Button
                  variant="primary"
                  onClick={playEpisode}
                  label={'Play Now'}
                  skinny={false}
                  fullWidth={false}
                  startIcon={<PlayArrowFilledIcon />}
                />
                <Button
                  variant="tertiary"
                  onClick={() => {
                    navigator.clipboard.writeText(window.location.href);
                    SnackbarUtils.success('Link copied to clipboard');
                  }}
                  label={'Share'}
                  skinny={false}
                  fullWidth={false}
                  startIcon={<ShareIcon />}
                />
              </Box>
            }
          />
        )}
      </Box>
      <AppFooter />
    </Box>
  );
};

const styles = {
  pageContainer: {
    margin: '0 auto',
    width: '100%',
    maxWidth: 'calc(1360px + 1.875rem)',
    background: 'white',
    backgroundColor: 'white',
  },
  fullWidthBox: (theme: Theme) => ({
    margin: 6,
    [theme.breakpoints.down('sm')]: {
      margin: '0 10px',
    },
  }),
};
